import { render, staticRenderFns } from "./InfoPedido.vue?vue&type=template&id=4a1d138c&scoped=true"
import script from "./InfoPedido.vue?vue&type=script&lang=js"
export * from "./InfoPedido.vue?vue&type=script&lang=js"
import style0 from "./InfoPedido.vue?vue&type=style&index=0&id=4a1d138c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d138c",
  null
  
)

export default component.exports